import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export default new Router({
  mode: 'history',
  base: '/h5',
  routes: [
    {
      path: '/',
      name: 'home',
      meta: {
        title: '首页'
      },
      component: resolve => require(['@/pages/home/home'], resolve)
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        title: '登录'
      },
      // component: resolve => require(['@/pages/login/Login'], resolve)web
      component: resolve => require(['@/pages/home/home'], resolve)
    },
    {
      path: '/guide',
      name: 'guide',
      meta: {
        title: '使用指南'
      },
      component: resolve => require(['@/pages/UseGuide/UseGuide'], resolve)
    },
    {
      path: '/point',
      name: 'point',
      meta: {
        title: '点位查询'
      },
      component: resolve => require(['@/pages/Points/Points'], resolve)
    },
    {
      path: '/user',
      name: 'user',
      meta: {
        title: '个人中心'
      },
      component: resolve => require(['@/pages/user/user'], resolve)
    },
    {
      path: '/deposit',
      name: 'deposit',
      meta: {
        title: ''
      },
      component: resolve => require(['@/pages/deposit/deposit'], resolve)
    },
    {
      path: '/balance',
      name: 'balance',
      meta: {
        title: '余额充值'
      },
      component: resolve => require(['@/pages/balance/balance'], resolve)
    },
    {
      path: '/reporting',
      name: 'reporting',
      meta: {
        title: '提交工单'
      },
      component: resolve => require(['@/pages/reporting/reporting'], resolve)
    },
    {
      path: '/ReturnUmbrella',
      name: 'ReturnUmbrella',
      meta: {
        title: '我要还伞'
      },
      component: resolve => require(['@/pages/ReturnUmbrella/ReturnUmbrella'], resolve)
    },
    {
      path: '/borrow',
      name: 'borrow',
      meta: {
        title: '我要还伞'
      },
      component: resolve => require(['@/pages/borrow/borrow'], resolve)
    },
    {
      path: '/record',
      name: 'record',
      meta: {
        title: '我要还伞'
      },
      component: resolve => require(['@/pages/record/record'], resolve)
    },
    {
      path: '/rechargeProtocol',
      name: 'rechargeProtocol',
      meta: {
        title: '充值协议'
      },
      component: resolve => require(['@/components/rechargeProtocol'], resolve)
    },
    {
      path: '/wallet',
      name: 'wallet',
      meta: {
        title: '我的钱包'
      },
      component: resolve => require(['@/pages/wallet/wallet'], resolve)
    },
    {
      path: '/returnDeposit',
      name: 'returnDeposit',
      meta: {
        title: '我要退押金'
      },
      component: resolve => require(['@/pages/returnDeposit/returnDeposit'], resolve)
    },
    {
      path: '/returnDepositSuc',
      name: 'returnDepositSuc',
      meta: {
        title: '退款成功'
      },
      component: resolve => require(['@/pages/returnDepositSuc/returnDepositSuc'], resolve)
    },
    {
      path: '/choseQues',
      name: 'choseQues',
      meta: {
        title: '客服中心'
      },
      component: resolve => require(['@/pages/choseQues/choseQues'], resolve)
    },
    {
      path: '/scheduleQuery',
      name: 'scheduleQuery',
      meta: {
        title: '进度查询'
      },
      component: resolve => require(['@/pages/scheduleQuery/scheduleQuery'], resolve)
    },
    {
      path: '/alipay',
      name: 'alipay',
      meta: {
        title: '支付宝支付'
      },
      component: resolve => require(['@/pages/alipay/alipay'], resolve)
    },
    {
      path: '/temp',
      name: 'tmp',
      meta: {
        title: '支付后跳转页面'
      },
      component: resolve => require(['@/pages/tmp/tmp'], resolve)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js